<template>
  <div id="footer" class="container-fluid">
    <div style="max-width: 1200px;height: 315px;margin: auto;background: rgba(255, 255, 255, 0);">
      <div class="footer-conter">
        <div class="footer-text" >
          <div style="display: flex">
            <img style="width: 4px;height: 20px;" src="@/static/footerBack.png">
            <div class="font1" style="margin-left: 4px">联系我们</div>
          </div>
          <div class="font2">深圳公司地址：广东省深圳市南山区深南大道10128号数字文化产业基地东塔楼2401-2402</div>
          <div class="font3">东莞公司地址：广东省东莞市南城寰宇汇金中心ucc2号楼1415</div>
          <div class="font3">西安公司地址：陕西省西安市碑林区铁安三街35栋2层</div>
          <div class="font4 mt76" >深圳市威斯登信息科技有限公司 Copyright© <span class="hover" onclick="window.open('https://beian.miit.gov.cn/')">粤ICP备19141537号-1</span></div>
        </div>
        <div class="footer-text">
          <div style="display: flex">
            <img style="width: 4px;height: 20px;" src="@/static/footerBack.png">
            <div class="font1" style="margin-left: 4px">咨询电话</div>
          </div>
          <div class="mt25"> <span class="name">李经理:</span> <span class="number">133 5297 8305</span> </div>
        </div>
        <div class="footer-right">
          <img class="logo" src="@/assets/img/wsd_vx.png">
          <div class="logo-title">公司公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  min-height: 315px;
  color: #fff;
  background: #0F1012;
  overflow: hidden;
  text-align: center;
}
.footer-conter{
  height: 315px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.footer-text {
  margin-top: 52px;
  height: 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.footer-right{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 90px;
  height: 90px;
}
.logo-title {
  margin-top: 10px;
  height: 22px;
  font-family: SourceHanSansCN-Medium;
  font-size: 12px;
  font-weight: 500;
  color: #FFFFFF;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}

.font1{
  width: 72px;
  height: 22px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.font2{
  margin-top: 31px;
  height: 12px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 12px;
  letter-spacing: 0em;
  color: #FFFFFF;
  z-index: 0
 }
.font3{
  margin-top: 14px;
  height: 12px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 12px;
  letter-spacing: 0em;
  color: #FFFFFF;
  z-index: 1
}
.font4{
  margin-top: 31px;
  height: 12px;
  font-family: SourceHanSansCN-Normal;
  font-size: 12px;
  font-weight: 350;
  line-height: 12px;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.hover:hover{
  color: #2462EE;
  background: #F1F1F1;
  cursor: pointer;
}
.mt76{
  margin-top: 76px;
}
.name{
  height: 12px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 12px;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.number{
  font-family: SourceHanSansCN-Regular;
  font-size: 24px;
  font-weight: normal;
  line-height: 12px;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.mt25{
  margin-top: 25px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue